var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBunny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88921 14.3338C3.6668 17.6673 6.17918 19.8896 6.73743 20.6433C6.9131 20.8804 5.88591 21.0007 5.88591 22.1119C5.88591 22.8661 6.9704 22.8661 6.9704 22.8661H15.2125C16.6388 21.0007 12.1059 20.8281 11.4153 21.0007C12.1059 19.9649 12.505 17.4384 11.6763 16.6098C10.6657 15.5991 9.20859 16.4269 8.37841 16.8294C8.10231 16.9632 7.90823 16.7663 8.10157 16.5281C8.61839 15.8911 9.91222 15.0709 11.4851 15.4641C13.5567 15.982 13.0444 19.064 12.5265 20.4451C15.8894 20.4451 16.9711 21.5563 16.2228 22.8661H17.8153C18.8205 22.8661 18.6673 20.4451 16.445 20.4451L16.445 18.2228C16.445 18.2228 16.445 17.6673 17.0005 17.1117C18.4174 15.6948 18.6665 15.445 18.6665 12.1115C18.6665 10.4032 18.7178 10.0148 19.2202 9.88921C21.4427 9.33363 21.9983 7.62925 21.9983 7.11133L22 6.55576C22 6.55576 20.5654 5.53747 20.3333 5.4446C17.5554 4.33345 15.9258 5.4446 15.3314 5.4446C15.3314 5.4446 13.3134 4.1682 11.9979 3.77788C10.2827 3.26896 7.5533 3.2223 7.5533 3.2223C7.5533 3.2223 10.3312 7.66691 14.2202 7.66691C14.2202 7.66691 14.2248 7.93137 14.2202 8.22248C14.1849 10.4448 7.86282 11.3735 5.88921 14.3338Z",
    fill: "url(#paint0_linear_25516_37362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3338 4.33345C13.1115 3.2223 11.4448 2.66673 10.3336 2.66673L9.77806 1C12.8893 1.44446 14.7782 3.40749 15.3338 4.33345Z",
    fill: "url(#paint1_linear_25516_37362)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4446 14.8894C6.4446 16.1167 5.44965 17.1117 4.2223 17.1117C2.99496 17.1117 2 16.1167 2 14.8894C2 13.662 2.99496 12.6671 4.2223 12.6671C5.44965 12.6671 6.4446 13.662 6.4446 14.8894Z",
    fill: "url(#paint2_linear_25516_37362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25516_37362",
    x1: 18.0604,
    y1: 29.7676,
    x2: 32.9557,
    y2: 14.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484275,
    stopColor: "#A3A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#8F8DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8DEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25516_37362",
    x1: 18.0604,
    y1: 29.7676,
    x2: 32.9557,
    y2: 14.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484275,
    stopColor: "#A3A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#8F8DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8DEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25516_37362",
    x1: 18.0604,
    y1: 29.7676,
    x2: 32.9557,
    y2: 14.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484275,
    stopColor: "#A3A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#8F8DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8DEF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunny);
export default __webpack_public_path__ + "static/media/bunny.62b87705173972d7de144bad23b24183.svg";
export { ForwardRef as ReactComponent };